/* cs-buybox.js - CineStore 3.0 buy-box certainty engine (Step 1.4).
   Reads per-variant data rendered by snippets/cs-buybox.liquid and shows:
   dual ex/inc VAT (only when variant taxable + UK market), RRP + savings, live stock
   state, a same-day-dispatch countdown to the 2pm cutoff, and an honest "arrives as
   early as" date that skips weekends/bank-holidays/closures.
   Backorder (tracked + continue-selling + qty <= 0): shows "Available to order"
   and hides the dispatch + arrival rows (restock lead time is not in our control).

   MADE TO ORDER (Aug 2026): when the block carries data-make-min > 0 the product is
   produced to order, so BOTH the same-day countdown and the arrival date are wrong
   and are suppressed. Instead the box states a typical production window in working
   days and says plainly that the timescale depends on artwork signoff, since the
   clock really starts when the customer approves the artwork and not when they order.
   Driven per product by the metafields custom.make_lead_min / custom.make_lead_max,
   so no code change is needed to add a product.

   ex/inc headline follows the site-wide VAT toggle (html.cs-vat-inc + 'cs:vat' event).
   RRP renders on its own line above the price and follows the same ex/inc toggle.
   Re-resolves on variant change via the product form [name="id"]. No core edits. */
(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-cs-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = {
      vatRate: parseFloat(root.getAttribute('data-vat-rate') || '0.2'),
      uk: root.getAttribute('data-uk') === '1'
    };
    /* Made-to-order production window, rendered by cs-buybox.liquid from the
       custom.make_lead_min / custom.make_lead_max product metafields. A min above
       zero is the single switch that makes this a made-to-order product. */
    var makeMin = parseInt(root.getAttribute('data-make-min') || '0', 10) || 0;
    var makeLabel = root.getAttribute('data-make-label') || '';
    var madeToOrder = makeMin > 0 && makeLabel !== '';
    /* Dispatch/arrival timing (2pm UK cutoff, closures, weekend skipping) comes
       from the shared engine assets/cs-ship.js so this page and the homepage Crew
       Favourites bar stay in lockstep and both measure the cutoff in UK time. */
    var ship = window.CSShip;
    var q = function (s) { return root.querySelector(s); };
    var els = {
      now: q('[data-cs-price-now]'), vatLab: q('[data-cs-vatlabel]'), wasRow: q('[data-cs-wasrow]'), rrp: q('[data-cs-rrp]'), save: q('[data-cs-save]'),
      second: q('[data-cs-secondprice]'), vatSwitch: q('[data-cs-vatswitch]'),
      stockRow: q('[data-cs-stockrow]'), stockTxt: q('[data-cs-stock]'),
      dispRow: q('[data-cs-disprow]'), dispTxt: q('[data-cs-dispatch]'),
      arrRow: q('[data-cs-arrrow]'), arrTxt: q('[data-cs-arrival]')
    };
    var mode = document.documentElement.classList.contains('cs-vat-inc') ? 'inc' : 'ex';
    /* Write innerHTML only when it actually changed. render() runs every second
       for the countdown; unconditional writes rebuilt identical nodes each tick,
       which killed :hover on the *estimated tooltip (visible flashing). */
    function setHTML(el, html) { if (el && el.csHtml !== html) { el.csHtml = html; el.innerHTML = html; } }
    function money(p) { return '£' + (p / 100).toFixed(2); }
    var DELIVERY_LINK = '<a class="cs-tip-link" href="https://www.cinestore.co.uk/pages/delivery">See more</a>';
    /* Tooltip for ordinary stock items: this IS a delivery estimate. */
    function tipStock() {
      return '<span class="cs-est">*estimated<span class="cs-tip">' +
        'All delivery timescales are Estimated not Guaranteed. For fastest delivery choose &lsquo;Express&rsquo; delivery at checkout. UK mainland &amp; Working Days only. Standard delivery takes a little longer. ' +
        DELIVERY_LINK + '</span></span>';
    }
    /* Tooltip for made-to-order items: this is NOT a delivery estimate, and the
       production clock depends on artwork signoff. Saying both plainly is the
       whole point of the made-to-order branch. */
    function tipMade() {
      return '<span class="cs-est">*production time<span class="cs-tip">' +
        'This is production time, not delivery time. Made to order items are engraved or printed for you before they are dispatched, so the timescale is typical and depends on when your artwork is signed off. Working Days are Monday to Friday, excluding bank holidays. Delivery time is added on top once the item leaves us. All timescales are Estimated not Guaranteed. ' +
        DELIVERY_LINK + '</span></span>';
    }
    function currentVariant() {
      var id = null;
      var form = root.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (form) { var inp = form.querySelector('[name="id"]'); if (inp) id = inp.value; }
      if (!id) { id = new URLSearchParams(location.search).get('variant'); }
      if (id && variants[id]) return variants[id];
      var k; for (k in variants) { if (variants[k].available) return variants[k]; }
      for (k in variants) { return variants[k]; }
      return null;
    }
    function render() {
      var v = currentVariant(); if (!v) return;
      var showInc = v.taxable && cfg.uk;
      var ex = money(v.price), inc = money(Math.round(v.price * (1 + cfg.vatRate)));
      setHTML(els.now, (mode === 'inc' && showInc) ? inc : ex);
      if (els.vatLab) els.vatLab.textContent = (mode === 'inc' && showInc) ? 'inc VAT' : (v.taxable ? 'ex VAT' : 'no VAT');
      if (els.rrp && els.save) {
        if (v.rrp && v.rrp > v.price) {
          /* RRP is stored ex VAT; follow the same ex/inc toggle as the headline price */
          var rrpShown = (mode === 'inc' && showInc) ? Math.round(v.rrp * (1 + cfg.vatRate)) : v.rrp;
          if (els.wasRow) els.wasRow.style.display = '';
          setHTML(els.rrp, money(rrpShown));
          els.save.style.display = ''; els.save.textContent = 'Save ' + Math.round((1 - v.price / v.rrp) * 100) + '%';
        } else { if (els.wasRow) els.wasRow.style.display = 'none'; els.save.style.display = 'none'; }
      }
      setHTML(els.second, showInc ? (mode === 'inc' ? ('ex VAT ' + ex) : ('inc VAT ' + inc)) : (v.taxable ? '' : 'VAT not charged on this item'));
      if (els.vatSwitch) els.vatSwitch.style.display = 'none';
      var avail = v.available, inv = v.inventory, low = v.lowstock, tracked = v.tracked;

      /* Made to order comes FIRST. These items are usually untracked, which would
         otherwise fall through to "In stock" and then promise same-day dispatch. */
      if (madeToOrder && avail) {
        if (els.stockRow) els.stockRow.className = 'cs-cbrow cs-stock made';
        setHTML(els.stockTxt, '<b>Made to order</b> &middot; typical timescale dependent on artwork signoff');
        if (els.arrRow) els.arrRow.style.display = 'none';
        if (els.dispRow) els.dispRow.style.display = '';
        setHTML(els.dispTxt, '<b>Dispatched in ' + makeLabel + '</b>' + tipMade());
        return;
      }

      var backorder = avail && tracked && inv <= 0;
      var state = !avail ? 'out' : (backorder ? 'back' : ((low && inv > 0 && inv <= low) ? 'low' : 'in'));
      if (els.stockRow) els.stockRow.className = 'cs-cbrow cs-stock ' + state;
      if (els.stockTxt) {
        if (state === 'out') setHTML(els.stockTxt, '<b>Out of stock</b>');
        else if (state === 'back') setHTML(els.stockTxt, '<b>Available to order</b> · we dispatch as soon as it is back in stock');
        else if (state === 'low') setHTML(els.stockTxt, '<b>Only ' + inv + ' left</b> · order soon');
        else setHTML(els.stockTxt, '<b>In stock</b>' + (inv > 0 ? (' · ' + (inv > 5 ? '5+' : inv) + ' ready to ship') : ''));
      }
      if (state === 'out' || state === 'back') { if (els.dispRow) els.dispRow.style.display = 'none'; if (els.arrRow) els.arrRow.style.display = 'none'; return; }
      if (els.dispRow) els.dispRow.style.display = ''; if (els.arrRow) els.arrRow.style.display = '';
      if (!ship) { if (els.dispRow) els.dispRow.style.display = 'none'; if (els.arrRow) els.arrRow.style.display = 'none'; return; }
      if (els.dispTxt) setHTML(els.dispTxt, ship.dispatchLineHtml());
      if (els.arrTxt) {
        var arrival = ship.getDispatch().arrival;
        setHTML(els.arrTxt, 'Arrives as early as <b>' + ship.fmt(arrival) + '</b>' + tipStock());
      }
    }
    render();
    /* Made-to-order copy is static, so skip the 1s countdown tick entirely. */
    if (!madeToOrder) setInterval(render, 1000);
    window.addEventListener('cs:vat', function (e) { mode = (e && e.detail === 'inc') ? 'inc' : 'ex'; render(); });
  }
  document.querySelectorAll('[data-cs-buybox]').forEach(init);
})();